import { connect } from 'react-redux';
import { authenticate } from '../../actions/actions-index';
import Login from '../../components/Auth/Login';
import { reduxForm } from "redux-form";
import * as _ from 'lodash';

function mapStateToProps(state, ownProps) {
    return {
    }
}

const validate = values => {
    const errors = {};
    if (!values.username) {
        errors.username = 'Required';
    }
    if (!values.password) {
        errors.password = 'Required';
    }
    if (!_.isEmpty(errors)) {
        errors._error = 'Error while submitting. Check invalid fields above.';
    }
    return errors;
};

let LoginForm = reduxForm({
    // a unique name for the form
    form: 'loginForm',
    validate
})(Login);

export default connect(
    mapStateToProps,
    {
        authenticate,
    }
)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/LoginContainer.js